import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './assets/global.css'
import './assets/design-tokens.css'
import { configureAmplify } from './amplifyConfig'

const app = createApp(App)
const pinia = createPinia()

// Configure AWS Amplify before the Vue app is created
configureAmplify()

app.use(pinia)
app.mount('#app') 